import React, { useState, useEffect, useMemo } from 'react';
import Moment from 'moment';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import { CardHeader, Row, Col, Collapse, FormGroup, Label, Input, Button, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Table, Modal, Form, ModalHeader, ModalBody, ModalFooter, Spinner, Badge } from 'reactstrap';
import { FaChevronRight, FaChevronUp, FaSave, FaChevronLeft, FaChevronDown } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import uuid from 'react-uuid';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Action from '../Action/Action';
import Documents from '../Uploads/Documents';
import ActionsToConsider from '../FarmApt/ActionsToConsider';
import { useNavigate, useLocation } from "react-router-dom";
import MapView from '../Map/MapView';
import ItemTypeListView from '../ItemsView/ItemTypeListView';
import MapType from '../ItemPopup/MapType';
import Validate from '../Validate/Validate';
import NutrientsItemView from './NutrientsItemView';
import RiskSummary from '../ItemsView/RiskSummary';
import moment from "moment";
import { useSearchParams } from 'react-router-dom';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import HistoricalActions from '../ItemsView/HistoricalActions';
import ItemTypeListViewForMap from '../ItemsView/ItemTypeListViewForMap';
import WholeFarmActionView from '../ItemsView/WholeFarmActionView';
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";
function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}
function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

const Nutrients = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage, refreshToken }) => {
    const [roleName, setRoleName] = useState(localStorage.getItem("roleName"));
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false); const [toggleSwitch, setToggleSwitch] = useState('map & details');
    //const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    //const isAddEditItem = localStorage.getItem("isAddEditItem");
    //const isCreateNewAction = localStorage.getItem("isCreateNewAction");
    const { state } = useLocation();
    const navigate = useNavigate();
    const [saving, setSaving] = useState('');
    const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const [loading, setLoading] = useState(true); const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [nutrients, setNutrients] = useState({
        outlineList: [], itemList: [], itemTypes: [], mapItemTypes: [], Section: 'Nutrients', SectionName: 'Nutrients', SectionObj: {}, isWizardCompleted: false, farmCenter: {},
        outlineCenter: {}, farmCenterTypeModel: {}, outlineItemTypes: [],
        actionTypes: [], contaminants: [], goodFarmingPractices: [], goodFarmingPracticeGroups: [], actions: [], seasonList: [], nutrientOLSENPList: [], sectionComment: '', isMapOnly: false, isMapRisk: true
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0 })
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, showLabel: false,
        isFarmOutlineEditable: false, zoomLevel: 15, polytype: '', itemsEditable: false, highlighteditemId: 0,isClear: false
    });
    const [isThisPageCompleted, setIsThisPageCompleted] = useState(false);
    const [actionsCount, setActionsCount] = useState(0);
    const [showActionPopup, setShowActionPopup] = useState(false);const [type, setType] = useState(0);const [name, setName] = useState('');const [actionType, setActionType] = useState(0);
    const [id, setId] = useState(0); const [activeTab, setActiveTab] = useState('3'); const [nutrientSeasonList, setNutrientSeasonList] = useState([]); const [sectionObj, setSectionObj] = useState({});
    const [seasonData, setSeasonData] = useState(
        {
            CurrentSeason: {season:"",systemDetail:'', nitrogen_Total_loss: null, phosphorous_Total_loss: null, nitrogen_Load_loss: null, phosphorous_Load_loss: null, nitrogen_Conversion_Efficiency_Per: null, n_Purchased_Surplus: null },
            CurrentSeasonMinus1: { season: "", systemDetail: '', nitrogen_Total_loss: null, phosphorous_Total_loss: null, nitrogen_Load_loss: null, phosphorous_Load_loss: null, nitrogen_Conversion_Efficiency_Per: null, n_Purchased_Surplus: null },
            CurrentSeasonMinus2: { season: "", systemDetail: '', nitrogen_Total_loss: null, phosphorous_Total_loss: null, nitrogen_Load_loss: null, phosphorous_Load_loss: null, nitrogen_Conversion_Efficiency_Per: null, n_Purchased_Surplus: null }
        });
    const [closedActionCount, setClosedActionCount] = useState(0); const [openActionCount, setOpenActionCount] = useState(0); const [isClosedActionShow, setIsClosedActionShow] = useState(false);
    const [nutrientOLSENPList, setNutrientOLSENPList] = useState([]);
    const [toggleItemTypeListState, setToggleItemTypeListState] = useState({ isOpen: true, isIconUp: true });
    const [nutrientPopup, setNutrientPopup] = useState({
        showNutrientPopup: false, mapitem: [], farmId: farmId, id: 0, markertype: '', perimeter: 0.0, coordinates: '', Name: '', color: "#21b546", Description: '', LMUId: 0, optimalRange: '', olsenpValueRange: '',
        date:null,dateText:''
    });
    const [nutrientPopupMaptype, setNutrientPopupMaptype] = useState({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
    const [nutrientDeletePopup, setNutrientDeletePopup] = useState({ showNutrientDeletePopup: false, id: 0 });
    const [typeid, setTypeId] = useState(0); const [itemPopupItemField, setItemPopupItemField] = useState({
        itemTypeId: 0
    });
    const [LMUParentList, setLMUParentList] = useState([]);
    let selectedLMUId = largeEnterpriseDetails != null ? largeEnterpriseDetails.selectedLMUId : 0;
    let selectedLMU = nutrientPopup.LMUId != null ? nutrientPopup.LMUId : selectedLMUId;
    let lmustyle = selectedLMUId > 0 && childCount == 0 && selectedLMUId == selectedLMU ? true : false
    const [childCount, setchildCount] = useState(0);
    const [nutrientHeader, setNutrientHeader] = useState({id:0,
        farmId: localStorage.getItem("defaultFarmId"), chkFertiliserApplications: false, chkYearlyApplication: false, chkNitrogenLeaching: false,
        chkFertiliserApplicationsComment: "", chkYearlyApplicationComment: "", chkNitrogenLeachingComment:""
    });
    const [savingNutrientDetails, setSavingNutrientDetails] = useState(''); const [savingNutrientManagement, setSavingNutrientManagement] = useState('');
    const [riskSummaryPopup, setRiskSummaryPopup] = useState({ showriskSummary: false }); const [searchParams, setSearchParams] = useSearchParams();
   /* const [nutrientManagement, setNutrientManagement] = useState({ WhoCompletesSoilTest: '', HowOftenSoilIsTested: '', WhichPaddocksAreDoneAndWhen: '', WhoIsSpreadingFertiliser: '', WhatMethodUsedForProofOfPlacement :''});*/
    const [nutrientManagement, setNutrientManagement] = useState({
        farmId: localStorage.getItem("defaultFarmId"), fertiliserTypeList: [], spreadTypeList: [], nitrogenRating: '', phosphorusRating: '', latestOlsenP: '', olsenPRange: '',
        opttestdate: null, opttestdateText: '', fertiliserapplieddate: null, applieddateText: '', fertiliserType: 0, spreadType: 0, applicationRate: '', measurementAndFertiliserUsed: '',
        areYouPlanningToUseNitrogenFertiliserInFiveYears: '', methodOfApplication: '', typeOfNitrogenFertiliser: '', rateOfNitrogenFertiliser: '', whenWillNitrogenFertiliserBeApply: '', nitrogenFertiliserNotes: '', dontApplyPhosphateFertiliser:''
 });
    const [wholeFarmActionPopup, setWholeFarmActionPopup] = useState({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const { height, width } = useWindowDimensions();
    useEffect(() => {
        setLoading(true);
        populateItemData();
    }, []);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const populateItemData = async () => {
        try {
            const response = await apiGet(
                '/api/nutrients/GetNutrients/', {
                params: { farmId: farmId }
            }
            );
            if (response.data.status) {
                setLoading(false);
                if (response.data.content.section != null) {
                    var section = window.wizardDetails.filter(x => x.controllerName == response.data.content.section.routePath);
                    if (section.length > 0) {
                        setIsNextButtonVisible(section[0].isSectionCompleted);
                    }
                }
                if (response.data.content.wizard.isNutrientsSaved) {
                    setIsThisPageCompleted(true);
                }
                else {
                    setIsThisPageCompleted(false);
                }

                setActionsCount(response.data.content.actions.length);

                //setNutrients({
                //    ...nutrients, outlineList: response.data.content.outlineList, itemList: response.data.content.nutrientItems, itemTypes: response.data.content.itemTypes,
                //    mapItemTypes: response.data.content.mapItemTypes, SectionObj: response.data.content.section, isWizardCompleted: response.data.content.isFWFPCompleted, farmCenter: response.data.content.farmCenter,
                //    actionTypes: response.data.content.actionTypes, contaminants: response.data.content.contaminants, goodFarmingPractices: response.data.content.goodFarmingPractices,
                //    goodFarmingPracticeGroups: response.data.content.goodFarmingPracticeGroups, actions: response.data.content.actions, sectionComment: response.data.content.sectionComment,
                //    outlineCenter: response.data.content.outlineCenter, farmCenterTypeModel: response.data.content.farmCenterTypeModel, outlineItemTypes: response.data.content.outlineItemTypes,
                //});
                setNutrients({
                    ...nutrients, outlineList: response.data.content.outlineList, itemTypes: response.data.content.itemTypes,
                    mapItemTypes: response.data.content.mapItemTypes, SectionObj: response.data.content.section, isWizardCompleted: response.data.content.isFWFPCompleted, farmCenter: response.data.content.farmCenter,
                    actionTypes: response.data.content.actionTypes, contaminants: response.data.content.contaminants, goodFarmingPractices: response.data.content.goodFarmingPractices,
                    goodFarmingPracticeGroups: response.data.content.goodFarmingPracticeGroups, actions: response.data.content.actions, sectionComment: response.data.content.sectionComment,
                    outlineCenter: response.data.content.outlineCenter, farmCenterTypeModel: response.data.content.farmCenterTypeModel, outlineItemTypes: response.data.content.outlineItemTypes,
                });

                const content = ContentState.createFromBlockArray(convertFromHTML(response.data.content.sectionComment == null ? '' : response.data.content.sectionComment))
                setEditorState(EditorState.createWithContent(content));
                setNutrientHeader({
                    ...nutrientHeader, id: response.data.content.nutrientHeader.id, chkFertiliserApplications: response.data.content.nutrientHeader.chkFertiliserApplications, chkYearlyApplication: response.data.content.nutrientHeader.chkYearlyApplication,
                    chkNitrogenLeaching: response.data.content.nutrientHeader.chkNitrogenLeaching, chkFertiliserApplicationsComment: response.data.content.nutrientHeader.chkFertiliserApplicationsComment,
                    chkYearlyApplicationComment: response.data.content.nutrientHeader.chkYearlyApplicationComment, chkNitrogenLeachingComment: response.data.content.nutrientHeader.chkNitrogenLeachingComment,
                })

                //setNutrientManagement({
                //    ...nutrientManagement, WhoCompletesSoilTest: response.data.content.whoCompletesSoilTest, HowOftenSoilIsTested: response.data.content.howOftenSoilIsTested
                //    , WhichPaddocksAreDoneAndWhen: response.data.content.whichPaddocksAreDoneAndWhen, WhoIsSpreadingFertiliser: response.data.content.whoIsSpreadingFertiliser
                //    , WhatMethodUsedForProofOfPlacement: response.data.content.whatMethodUsedForProofOfPlacement
                //})

                var opttestdate = null;
                var opttestdateText = '';
                if (response.data.content.opTtestDate != null) {
                    opttestdate = getDateFromString(moment(response.data.content.opTtestDate).format("DD/MM/YYYY"));
                    opttestdateText = getParsedDate(opttestdate);
                }

                var fertiliserapplieddate = null;
                var applieddateText = '';
                if (response.data.content.fertiliserAppliedDate != null) {
                    fertiliserapplieddate = getDateFromString(moment(response.data.content.fertiliserAppliedDate).format("DD/MM/YYYY"));
                    applieddateText = getParsedDate(fertiliserapplieddate);
                }

                setNutrientManagement({
                    ...nutrientManagement, fertiliserTypeList: response.data.content.fertiliserTypeList, spreadTypeList: response.data.content.spreadTypeList, nitrogenRating: response.data.content.nitrogenRating,
                    phosphorusRating: response.data.content.phosphorousRating, latestOlsenP: response.data.content.latestOlsenP, olsenPRange: response.data.content.olsenPRange, opttestdate: opttestdate, opttestdateText: opttestdateText,
                    fertiliserapplieddate: fertiliserapplieddate, applieddateText: applieddateText, fertiliserType: response.data.content.fertiliserType, spreadType: response.data.content.spreadType, applicationRate: response.data.content.applicationRate,
                    measurementAndFertiliserUsed: response.data.content.measurementAndFertiliserUsed,
                    areYouPlanningToUseNitrogenFertiliserInFiveYears: response.data.content.areYouPlanningToUseNitrogenFertiliserInFiveYears,
                    methodOfApplication: response.data.content.methodOfApplication,
                    typeOfNitrogenFertiliser: response.data.content.typeOfNitrogenFertiliser,
                    rateOfNitrogenFertiliser: response.data.content.rateOfNitrogenFertiliser,
                    whenWillNitrogenFertiliserBeApply: response.data.content.whenWillNitrogenFertiliserBeApply,
                    nitrogenFertiliserNotes: response.data.content.nitrogenFertiliserNotes, dontApplyPhosphateFertiliser: response.data.content.dontApplyPhosphateFertiliser,
                })
                setMapDetails({ ...mapDetails, zoomLevel: response.data.content.selectedZoomlevel });
                setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.content.islargeEnterprise, LMUList: response.data.content.lmuItemList })
                setNutrientSeasonList(response.data.content.seasonList);
                setSeasonData({
                    ...seasonData,
                    CurrentSeason: response.data.content.currentSeason
                    , CurrentSeasonMinus1: response.data.content.currentSeasonMinus1, CurrentSeasonMinus2: response.data.content.currentSeasonMinus2
                });
                setOpenActionCount(response.data.content.actions.filter(action => action.isCloseout != true).length);
                setShow_HistoricalActions(response.data.content.show_HistoricalActions);
                setShow_SectionComment(response.data.content.show_SectionComment);
                setClosedActionCount(response.data.content.actions.filter(action => action.isCloseout == true).length);
                setNutrientOLSENPList(response.data.content.nutrientOLSENPList);
                setSectionObj(response.data.content.section);
                if (state != null) {
                    const { itemId, actionId, navigateFrom } = state;
                    navigate(state.pathname, { replace: true });
                    if (navigateFrom == "Actions") {
                        handleNavigateOpenActionPopup(itemId, actionId, response.data.content);
                    }
                }
                let search = window.location.search;
                let params = new URLSearchParams(search);
                let navigateFrom = params.get('navigateFrom');
                if (navigateFrom == 'Actions') {
                    let actionId = params.get('actionId');
                    let itemId = params.get('itemId');
                    let isWholeFarmAction = params.get('isWholeFarmAction');
                    if (searchParams.has('actionId')) {
                        searchParams.delete('actionId');
                        setSearchParams(searchParams);
                    }
                    if (searchParams.has('itemId')) {
                        searchParams.delete('itemId');
                        setSearchParams(searchParams);
                    }
                    if (searchParams.has('isWholeFarmAction')) {
                        searchParams.delete('isWholeFarmAction');
                        setSearchParams(searchParams);
                    }
                    if (searchParams.has('navigateFrom')) {
                        searchParams.delete('navigateFrom');
                        setSearchParams(searchParams);
                    }
                    if (navigateFrom == "Actions") {
                        handleNavigateOpenActionPopup(itemId, actionId, response.data.content);
                    }
                }
            }
            
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    const handleNavigateOpenActionPopup = (itemId, actionId, ghg) => {
        setShowActionPopup(true);
        setId(actionId)
    };

    const handleOpenActionPopup = async (e) => {
        setShowActionPopup(true);
        setId(0)
    };

    const handleOpenAction = async (e, item) => {
        setShowActionPopup(true);
        setId(item.id)
    };

    function handleActionClose() {
        setShowActionPopup(false);
    }

    //function handleClosedActionShow(event) {
    //    setIsClosedActionShow(event.target.checked);
    //}

    //const addMapItem = (mapItem, mapType) => {
    //    let path, area = 0.0, perimeter = 0.0, coordinates = '';
    //    var selectedItemType = nutrients.mapItemTypes.filter(item => item.id == typeid)[0];
    //    const ItemTypeName = selectedItemType.name;
    //    var LMUParentListTemp = largeEnterpriseDetails.selectedLMUId > 0 ? largeEnterpriseDetails.LMUList.filter(lmu => !lmu.isConnectedToAnotherLMU && lmu.id == largeEnterpriseDetails.selectedLMUId) :
    //        largeEnterpriseDetails.LMUList.filter(lmu => !lmu.isConnectedToAnotherLMU);
    //    setLMUParentList(LMUParentListTemp);
    //    var childCountTemp = largeEnterpriseDetails.LMUList.filter(child => child.lmuId == selectedLMU).length;
    //    setchildCount(childCountTemp)
    //    if (mapType == 'polyline') {
    //        path = mapItem.getPath();
    //        area = 0;
    //        perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
    //        var PolygonCoords = "";
    //        path.getArray().map((pointCo) => {

    //            PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
    //        })
    //        coordinates = PolygonCoords;
    //        if (path.getArray().length <= 1) {
    //            toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
    //            resetValues();
    //            return false;
    //        }
    //    }
    //    setNutrientPopup({
    //        ...nutrientPopup, showNutrientPopup: true, mapitem: mapItem, farmId: farmId, id: 0, markertype: mapType, perimeter: perimeter, coordinates: coordinates,
    //        Name: '', color: '#21b546', Description: '', LMUId: 0, olsenpValueRange: '', optimalRange: '', date: null, dateText:''
    //    });
    //    setNutrientPopupMaptype({ ...nutrientPopupMaptype, markertype: mapType, area: area, perimeter: perimeter, coordinates: coordinates });
    //}

    //function handleItemEditPopup(itemId) {
    //    editMapItem([], itemId, false)
    //}

    //const handleMapItemEdited = (itemId, type, strValue) => {
    //    let name = '';
    //    let value = '';
        
    //    if (type == "polygonBoundsChanged") {
    //        name = 'mapCoordinates';
    //        var PolygonCoords = "";
    //        strValue.getArray().map((pointCo) => {
    //            PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
    //        })
    //        value = PolygonCoords;
    //    }
    //    else if (type == "polylineBoundsChanged") {
    //        name = 'mapCoordinates';
    //        var PolygonCoords = "";
    //        strValue.getArray().map((pointCo) => {
    //            PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
    //        })
    //        value = PolygonCoords;
    //    }

    //    const itemList = nutrients.itemList.map(item =>
    //        item.itemId === itemId
    //            ? { ...item, [name]: value, isEdited: true }
    //            : item
    //    )
    //    setNutrients({ ...nutrients, itemList: itemList });
    //}

    //const editMapItem = (mapItem, itemId, isDragged) => {
    //    var nutrient = nutrients.itemList.filter(x => x.itemId == itemId)[0];
    //    let coordinates = nutrient.mapCoordinates;
    //    let area = 0.0, perimeter = 0.0;
    //    if (nutrient.mapMarkerType == "polyline") {
    //        const Coordinates = coordinates.split(':');
    //        const positions = [];
    //        Coordinates.filter(coor => coor != "").map((Coordinate) => {
    //            const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
    //            positions.push(pos);
    //        })
    //        const tempPolyline = new window.google.maps.Polyline({
    //            paths: positions
    //        });
    //        let path = tempPolyline.paths;
    //        area = nutrient.area;
    //        perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
    //        if (path.length <= 1) {
    //            toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
    //            resetValues();
    //            return false;
    //        }
    //    }
    //    var LMUParentListTemp = largeEnterpriseDetails.selectedLMUId > 0 ? largeEnterpriseDetails.LMUList.filter(lmu => !lmu.isConnectedToAnotherLMU && lmu.id == largeEnterpriseDetails.selectedLMUId) :
    //        largeEnterpriseDetails.LMUList.filter(lmu => !lmu.isConnectedToAnotherLMU);
    //    setLMUParentList(LMUParentListTemp);
    //    var childCountTemp = largeEnterpriseDetails.LMUList.filter(child => child.lmuId == nutrient.lmuId).length;
    //    setchildCount(childCountTemp);
    //    var Date = null;
    //    var DateText = '';
    //    if (nutrient.date != null) {
    //        Date = getDateFromString(moment(nutrient.date).format("DD/MM/YYYY")) ;
    //        DateText = getParsedDate(Date);
    //    }
    //    setNutrientPopup({
    //        ...nutrientPopup, showNutrientPopup: true, mapitem: mapItem, farmId: farmId, id: itemId, markertype: nutrient.mapMarkerType, perimeter: perimeter, coordinates: coordinates,
    //        Name: nutrient.name, color: nutrient.colour, Description: nutrient.description, LMUId: nutrient.lmuId, olsenpValueRange: nutrient.olsenpValueRange,
    //        optimalRange: nutrient.optimalRange, date: Date, dateText: DateText
    //    });
    //    setNutrientPopupMaptype({ ...nutrientPopupMaptype, markertype: nutrient.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates });
    //}

    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }

    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    function handleClearSelection() {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: 0 });
        window.location.reload(true);
    }

    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: typeid });
    }

    const handleItemTypeListTogole = (isOpen, isIconUp) => {
        setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    //function handleNutrientPopupClose() {
    //    resetValues();
    //}

    //function resetValues() {
    //    setNutrientPopup({
    //        ...nutrientPopup, showNutrientPopup: false, mapitem: [], farmId: farmId, id: 0, markertype: '', perimeter: 0.0, coordinates: '', Name: '', color: '#21b546', Description: '',
    //        LMUId: 0, olsenpValueRange: '', optimalRange:''
    //    });
    //    setNutrientDeletePopup({ showNutrientDeletePopup: false, id: 0 });
    //    setMapDetails({ ...mapDetails, isClear: true });
    //}

    //function handleNutrientItemsChange(event) {
    //    const { name, value, checked, type } = event.target;
    //    setNutrientPopup({ ...nutrientPopup, [name]: type == 'checkbox' ? checked : value });
    //}

    //function handleNutrientDeletePopup(id) {
    //    setNutrientDeletePopup({ showNutrientDeletePopup: true, id: id });
    //}

    //const handleNutrientSubmit = async (event) => {
    //    setSaving(true);
    //    let form = {
    //        Id: nutrientPopup.id,
    //        MapMarkerType: nutrientPopup.markertype,
    //        FarmId: nutrientPopup.farmId,
    //        Name: nutrientPopup.Name,
    //        Description: nutrientPopup.Description,
    //        Colour: nutrientPopup.color,
    //        Length: nutrientPopup.perimeter,
    //        MapCoordinates: nutrientPopup.coordinates,
    //        UserId: userId,
    //        LMUId: nutrientPopup.LMUId,
    //        OptimalRange: nutrientPopup.optimalRange,
    //        OLSENPValueRange: nutrientPopup.olsenpValueRange,
    //        Date: nutrientPopup.dateText
    //    }
    //    if (!Validate(form)) {
    //        try {
    //            const response = await apiPost(
    //                '/api/nutrients/SaveNutrients/', JSON.stringify(form),
    //                {
    //                    headers: { 'Content-Type': 'application/json' },
    //                    withCredentials: true
    //                });
    //            if (response.data != null) {
    //                await refreshItemDetails();
    //                handleNutrientPopupClose();
    //                setSaving(false);
    //            }
    //        } catch (error) {
    //            setSaving(false);
    //            console.error('Error:', error);
    //        }
    //    }
    //}

    const refreshItemDetails = async () => {
        const response = await apiGet(
            '/api/nutrients/GetNutrients/', {
            params: { farmId: farmId }
        }
        );
        if (response.data.status) {
            setNutrients({
                ...nutrients, itemList: response.data.content.nutrientItems, outlineCenter: response.data.content.outlineCenter
            });
            setActionsCount(response.data.content.actions.length);
        }
    }

    //function handleItemDeletePopupClose() {
    //    setNutrientDeletePopup({ showNutrientDeletePopup: false, itemId: 0 });
    //}

    //const deleteItembyId = async (id) => {
    //    try {
    //        setItemDeleteSaving(true);
    //        const response = await apiGet(
    //            '/api/nutrients/DeleteNutrients/', {
    //            params: {
    //                    itemId: id, userId: userId
    //            }
    //        }
    //        );
    //        if (response.data != null) {
    //            await refreshItemDetails();
    //            handleNutrientPopupClose();
    //            setItemDeleteSaving(false);
    //        }
    //    } catch (error) {
    //        setItemDeleteSaving(false);
    //        console.error('Error:', error);
    //    }
    //}

    //const deleteItem = async (event) => {
    //    setItemDeleteSaving(true);
    //    const itemid = nutrientDeletePopup.id;
    //    try {
    //        const response = await apiGet(
    //            '/api/nutrients/DeleteNutrients/', {
    //            params: {
    //                itemId: itemid, userId: userId
    //            }
    //        }
    //        );
    //        if (response.data != null) {
    //            await refreshItemDetails();
    //            handleNutrientPopupClose();
    //            setItemDeleteSaving(false);
    //        }
    //    } catch (error) {
    //        setItemDeleteSaving(false);
    //        console.error('Error:', error);
    //    }
    //}

    //const seasonDataChange = async (event,object,variable) => {
    //    let tempSeasonData = seasonData;
    //    if (object == "CurrentSeason") {
    //        if (variable == "nitrogen_Total_loss") {
    //            tempSeasonData.CurrentSeason.nitrogen_Total_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "systemDetail") {
    //            tempSeasonData.CurrentSeason.systemDetail = event.target.value;
    //        }
    //        else if (variable == "phosphorous_Total_loss") {
    //            tempSeasonData.CurrentSeason.phosphorous_Total_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "nitrogen_Load_loss") {
    //            tempSeasonData.CurrentSeason.nitrogen_Load_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "phosphorous_Load_loss") {
    //            tempSeasonData.CurrentSeason.phosphorous_Load_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "nitrogen_Conversion_Efficiency_Per") {
    //            tempSeasonData.CurrentSeason.nitrogen_Conversion_Efficiency_Per = parseFloat(event.target.value);
    //        }
    //        else if (variable == "n_Purchased_Surplus") {
    //            tempSeasonData.CurrentSeason.n_Purchased_Surplus = parseFloat(event.target.value);
    //        }
    //    }
    //    else if (object == "CurrentSeasonMinus1") {
    //        if (variable == "nitrogen_Total_loss") {
    //            tempSeasonData.CurrentSeasonMinus1.nitrogen_Total_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "systemDetail") {
    //            tempSeasonData.CurrentSeasonMinus1.systemDetail = event.target.value;
    //        }
    //        else if (variable == "phosphorous_Total_loss") {
    //            tempSeasonData.CurrentSeasonMinus1.phosphorous_Total_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "nitrogen_Load_loss") {
    //            tempSeasonData.CurrentSeasonMinus1.nitrogen_Load_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "phosphorous_Load_loss") {
    //            tempSeasonData.CurrentSeasonMinus1.phosphorous_Load_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "nitrogen_Conversion_Efficiency_Per") {
    //            tempSeasonData.CurrentSeasonMinus1.nitrogen_Conversion_Efficiency_Per = parseFloat(event.target.value);
    //        }
    //        else if (variable == "n_Purchased_Surplus") {
    //            tempSeasonData.CurrentSeasonMinus1.n_Purchased_Surplus = parseFloat(event.target.value);
    //        }
    //    }
    //    else if (object == "CurrentSeasonMinus2") {
    //        if (variable == "nitrogen_Total_loss") {
    //            tempSeasonData.CurrentSeasonMinus2.nitrogen_Total_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "systemDetail") {
    //            tempSeasonData.CurrentSeasonMinus2.systemDetail = event.target.value;
    //        }
    //        else if (variable == "phosphorous_Total_loss") {
    //            tempSeasonData.CurrentSeasonMinus2.phosphorous_Total_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "nitrogen_Load_loss") {
    //            tempSeasonData.CurrentSeasonMinus2.nitrogen_Load_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "phosphorous_Load_loss") {
    //            tempSeasonData.CurrentSeasonMinus2.phosphorous_Load_loss = parseFloat(event.target.value);
    //        }
    //        else if (variable == "nitrogen_Conversion_Efficiency_Per") {
    //            tempSeasonData.CurrentSeasonMinus2.nitrogen_Conversion_Efficiency_Per = parseFloat(event.target.value);
    //        }
    //        else if (variable == "n_Purchased_Surplus") {
    //            tempSeasonData.CurrentSeasonMinus2.n_Purchased_Surplus = parseFloat(event.target.value);
    //        }
    //    }
    //    setSeasonData({
    //        ...seasonData,
    //        CurrentSeason: tempSeasonData.CurrentSeason, CurrentSeasonMinus1: tempSeasonData.CurrentSeasonMinus1, CurrentSeasonMinus2: tempSeasonData.CurrentSeasonMinus2
    //    });
    //}
    const [savingNext, setSavingNext] = useState(false); const [savingBack, setSavingBack] = useState(false);
    const [savingNutrientDetail, setSavingNutrientDetail] = useState(false);
    const handleNutrientDetailSave = async (e, from, section, method) => {
        e.preventDefault()
        if (from == '') {
            setSavingNutrientDetail(true);
        }
        else if (from == 'Next') {
            setSavingNext(true);
        }
        else if (from == 'Back') {
            setSavingBack(true);
        }
        await handleNutrientManagementSubmit(e);
        toast.success("Nutrient Detail saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        if (from == '') {
            setSavingNutrientDetail(false);
            refreshToken();
        }
        else if (from == 'Next') {
            setSavingNext(false);
            method(section);
        }
        else if (from == 'Back') {
            setSavingBack(false);
            method(section);
        }
        
    }

    const handleNutrientManagementSubmit = async (e) => {
        e.preventDefault();
        //setSavingNutrientManagement(true);

        let form = {
            FarmId: nutrientManagement.farmId,
            LatestOlsenP : nutrientManagement.latestOlsenP,
            OlsenPRange : nutrientManagement.olsenPRange,
            OPTtestDate: nutrientManagement.opttestDate,
            OPTtestDateText: nutrientManagement.opttestdateText,
            FertiliserAppliedDate: nutrientManagement.fertiliserAppliedDate,
            AppliedDateText: nutrientManagement.dontApplyPhosphateFertiliser == 'Yes' ? nutrientManagement.applieddateText : '',
            FertiliserType: nutrientManagement.dontApplyPhosphateFertiliser == 'Yes' ? nutrientManagement.fertiliserType : null,
            SpreadType: nutrientManagement.dontApplyPhosphateFertiliser == 'Yes' ? nutrientManagement.spreadType : null,
            ApplicationRate: nutrientManagement.dontApplyPhosphateFertiliser == 'Yes' ? nutrientManagement.applicationRate : null,
            MeasurementAndFertiliserUsed: nutrientManagement.measurementAndFertiliserUsed,
            DontApplyPhosphateFertiliser: nutrientManagement.dontApplyPhosphateFertiliser,
            AreYouPlanningToUseNitrogenFertiliserInFiveYears: nutrientManagement.areYouPlanningToUseNitrogenFertiliserInFiveYears,
            MethodOfApplication: nutrientManagement.areYouPlanningToUseNitrogenFertiliserInFiveYears == 'Yes' ? nutrientManagement.methodOfApplication : null,
            TypeOfNitrogenFertiliser: nutrientManagement.areYouPlanningToUseNitrogenFertiliserInFiveYears == 'Yes' ? nutrientManagement.typeOfNitrogenFertiliser : null,
            RateOfNitrogenFertiliser: nutrientManagement.areYouPlanningToUseNitrogenFertiliserInFiveYears == 'Yes' ? nutrientManagement.rateOfNitrogenFertiliser : null,
            WhenWillNitrogenFertiliserBeApply: nutrientManagement.areYouPlanningToUseNitrogenFertiliserInFiveYears == 'Yes' ? nutrientManagement.whenWillNitrogenFertiliserBeApply : null,
            NitrogenFertiliserNotes: nutrientManagement.areYouPlanningToUseNitrogenFertiliserInFiveYears == 'Yes' ? nutrientManagement.nitrogenFertiliserNotes : null,
        }

        try {
            const response = await apiPost(
                '/api/nutrients/SaveNutrientManagement/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                
                //setSavingNutrientManagement(false);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleRiskSummaryClose = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: false })
        window.location.reload(true);
    }

    const handleRiskSummaryOpen = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: true })
    }

    const handleActionToggle = (isOpen, isIconUp) => {
        setIsOpen()
    }

    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '80vw' : '50vw'}
                height={toggleSwitch == 'map' ? '80vw' : '50vw'}
                itemModel={nutrients}
                mapDetails={mapDetails}
                  largeEnterpriseDetails={largeEnterpriseDetails}
            ></MapView>
        )
    }, [nutrients, mapDetails, largeEnterpriseDetails, toggleSwitch])

    const itemTypeListView = useMemo(() => {

        return (
            <ItemTypeListViewForMap isWizardCompleted={nutrients.isWizardCompleted} Section={nutrients.Section}
                itemTypesList={nutrients.mapItemTypes}
                toggleItemTypeListState={toggleItemTypeListState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemTypeListTogole={handleItemTypeListTogole}
                itemModel={nutrients}
            >
            </ItemTypeListViewForMap>
        )
    }, [nutrients, largeEnterpriseDetails, nutrients.SectionObj, toggleItemTypeListState, nutrients.outlineCenter])

    const nonMapView = useMemo(() => {
        return (
            <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                <Row>
                    <Col>
                        <ItemTypeListView Section={nutrients.Section}
                            itemTypesList={nutrients.mapItemTypes}
                            toggleItemTypeListState={toggleItemTypeListState}
                            handleClearSelection={handleClearSelection}
                            handleItemClick={handleItemClick}
                            handleItemTypeListTogole={handleItemTypeListTogole}
                            itemModel={nutrients}
                        >
                        </ItemTypeListView>
                    </Col>
                </Row>
                {/*{nutrients.itemList != undefined && nutrients.itemList != null && nutrients.itemList.map((item, idx) => (*/}
                {/*    <NutrientsItemView key={uuid()} handleNutrientDeletePopup={handleNutrientDeletePopup} handleItemEditPopup={handleItemEditPopup} nutrientsItem={item} handleItemHighlight={handleItemHighlight}></NutrientsItemView>*/}
                {/*))}*/}
            </div>
        )
    }, [nutrients, toggleItemTypeListState])

    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
        setIsIconUp(!isIconUp);
    };

    const [soilTestIsOpen, setSoilTestIsOpen] = useState(true);
    const [soilTestIsIconUp, setSoilTestIsIconUp] = useState(true);
    const soilTestToggle = () => {
        setSoilTestIsOpen(!soilTestIsOpen);
        setSoilTestIsIconUp(!soilTestIsIconUp);
    };

    

    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setNutrients({ ...nutrients, sectionComment: value })
    }

    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }
    const [checkActionPopup, setCheckActionPopup] = useState({ showPopup: false, section: '', method: '' });
    const handleCheckActionPopupClose = () => {
        setCheckActionPopup({ showPopup: false, section: '', method: '' });
    }

    const handleOpenWholeActionPopup = (itemId, actionId) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: nutrients.outlineCenter.itemTypeId, itemName: 'NA', actionId: actionId });
    };

    const handleWholeActionClose = () => {
        setWholeFarmActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    const handleCheckCalculatorDataPopupConfirm = async (e) => {
        await handleNutrientDetailSave(e, 'Next', nutrients.Section, handleWizardChanged);
    }

    const checkAction = async (e,from,section, method) => {
        if (!isThisPageCompleted && actionsCount == 0) {
            setCheckActionPopup({ showPopup: true, section: section, method: method });
        }
        else {
            await handleNutrientDetailSave(e, from, section, method);
        }
    }

    const [savingSectionComment, setSavingSectionComment] = useState('');

    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/nutrients/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }

    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/nutrients/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
        } catch (err) {
            console.log(err);
        }
    }

    const CustomToastWithLink = () => (
        <div>
            <p>The first form is where you can select, from a drop-down, what risk or risks the action will be mitigating. After you’ve selected the risk, a secondary form will open, and you can complete what land units this action will take place on. In addition, you can choose from a drop-down of possible actions to mitigate this risk. When you’ve chosen an action click on select and you’ll be taken back to the primary form. It will now show your selections and you can complete the additional information and “Save.”</p>
        </div>
    );
    const customId = "custom-id-yes1";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    function handleInputChange(event) {
        const { name, value, checked, type } = event.target;
        setNutrientManagement({ ...nutrientManagement, [name]: type == 'checkbox' ? checked : value });
    }

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }
    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error(
                (t) => (
                    <div>
                        <span>ALERT: when editing a shape remember to click inside the shape when finished, or when editing a line double click on the line, to save any changes.</span>
                        <button className="toast-close-button"
                            onClick={() => toast.dismiss(t.id)}
                        >
                            OK
                        </button>
                    </div>
                ),
                {
                    duration: Infinity, style: { border: '1px solid #f76054', padding: '16*/px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', }
                }
            );
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable })
    }

    

    return (
        <div>
            <Modal isOpen={checkActionPopup.showPopup}>
                <ModalHeader toggle={handleCheckActionPopupClose} >Confirm</ModalHeader>
                <ModalBody>
                    Confirm : you have not created any actions on this page. Are you sure you wish to continue? Select ‘No’ if you wish to stay on this page to finish creating actions, or Yes to continue.
                </ModalBody>
                <ModalFooter>
                    <Button onClick={(e) => handleCheckCalculatorDataPopupConfirm(e)} color="primary">
                        Yes
                    </Button>{' '}
                    <Button color="danger" onClick={handleCheckActionPopupClose}>No</Button>
                </ModalFooter>
            </Modal>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">Nutrient Management</h3></Col>
                <Col>
                    {nutrients.isWizardCompleted != true && !loading &&
                        <>
                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') ?
                            <>
                                {savingNext ?
                                    <Button className="float-end btn-next-page" onClick={(e) => checkAction(e, 'Next', nutrients.Section, handleWizardChanged)}
                                        disabled
                                    >
                                        <Row>
                                            <Col sm="8">
                                                <span>
                                                    {' '}Processing
                                                </span>
                                            </Col>
                                            <Col sm="4">
                                                <Spinner size="sm">
                                                    Processing...
                                                </Spinner>
                                            </Col>
                                        </Row>
                                    </Button>
                                    :
                                    <Button className="float-end btn-next-page" onClick={(e) => checkAction(e, 'Next', nutrients.Section, handleWizardChanged)} >
                                        Next <FaChevronRight />
                                    </Button>
                                }
                                {savingNutrientDetail ?
                                    <Button className="float-end btn-next-page" onClick={(e) => handleNutrientDetailSave(e, '', '', null)}
                                        disabled
                                    >
                                        <Row>
                                            <Col sm="8">
                                                <span>
                                                    {' '}Saving
                                                </span>
                                            </Col>
                                            <Col sm="4">
                                                <Spinner size="sm">
                                                    Saving...
                                                </Spinner>
                                            </Col>
                                        </Row>
                                    </Button>
                                    :
                                    <Button className="float-end btn-next-page" onClick={(e) => handleNutrientDetailSave(e, '', '', null)} >
                                        Save 
                                    </Button>
                                }
                                {savingBack ?
                                    <Button className="float-end btn-next-page" onClick={(e) => handleNutrientDetailSave(e, 'Back', nutrients.Section, handleWizardChangedBack)}
                                        disabled
                                    >
                                        <Row>
                                            <Col sm="8">
                                                <span>
                                                    {' '}Processing
                                                </span>
                                            </Col>
                                            <Col sm="4">
                                                <Spinner size="sm">
                                                    Processing...
                                                </Spinner>
                                            </Col>
                                        </Row>
                                    </Button>
                                    :
                                    <Button className="float-end btn-next-page" onClick={(e) => handleNutrientDetailSave(e, 'Back', nutrients.Section, handleWizardChangedBack)} >
                                        Back <FaChevronLeft />
                                    </Button>
                                }
                            </>
                            
                            :
                            <>
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(nutrients.Section, 'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(nutrients.Section, 'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                            </>
                            
                        }
                        </>
                    }
                </Col>
                
            </Row>
            <br />
            {loading ? <SpinnerContainer /> :
                <Row style={{ marginTop: '10px' }}>
                    <Col id='mapView'>
                        <Row className="map-layer">
                            <Col>
                                <Row>
                                    <Col sm="3"> {toggleSwitch == 'map & details' &&
                                        <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                            <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                        </Button>
                                    }
                                        {toggleSwitch == 'map' &&
                                            <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                    </Col>
                                    <Col sm="1"></Col>
                                    <Col sm="8">
                                        <div className="map-item-edit-div">
                                            <Label className="map-checkbox-label">Show LU layer</Label>
                                            <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={largeEnterpriseDetails.isSmallEnterpriseShow} onChange={(e) => setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isSmallEnterpriseShow: !largeEnterpriseDetails.isSmallEnterpriseShow })} name="isSmallEnterpriseShow" id="isSmallEnterpriseShow" />&nbsp;&nbsp;
                                            <Label className="map-checkbox-label">Edit Item</Label>
                                            <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />&nbsp;&nbsp;
                                            <Label className="map-checkbox-label">Show Label</Label>
                                            <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                        </div>
                                    </Col>
                                </Row>
                                {mapView}
                            </Col>
                        </Row>

                    </Col>

                    <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "20vw" }}>
                        <br />
                        {itemTypeListView}
                        <br />
                    </Col>

                    <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', marginTop: "-25px" }}>
                        <Row>
                            <Col>
                                {toggleSwitch == 'map & details' &&
                                    <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                        <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                    </Button>
                                }
                                {toggleSwitch == 'details' &&
                                    <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                        <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                    </Button>
                                }
                                {
                                    !loading && <Button style={{ marginLeft: "0.5vw", backgroundColor: "#41533d" }} onClick={() => handleRiskSummaryOpen()} className="btn btn-risk-summaryv1">View Risk and Action Summary</Button>
                                }
                            </Col>
                        </Row>
                        {nonMapView}
                        {show_SectionComment &&  
                            <Row>
                                <Col sm="12">
                                    <FormGroup>
                                        <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Section Comment</b> <span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span></Label>
                                        <Editor handlePastedText={() => false}
                                            defaultEditorState={editorState}
                                            onEditorStateChange={setEditorState}
                                            wrapperClassName="wrapper-class"
                                            editorClassName="editor-class"
                                            toolbarClassName="toolbar-class"
                                            toolbar={
                                                {
                                                    options: ['inline'], inline: {
                                                        inDropdown: false,
                                                        options: ['bold', 'italic', 'underline'],
                                                    }
                                                }
                                            }
                                        />
                                    </FormGroup>

                                </Col>
                                <Col sm="12">
                                    {savingSectionComment ?
                                        <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                            <Row>
                                                <Col sm="8">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="4">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                            Save
                                        </Button>
                                    }
                                </Col>
                            </Row>    
                        }

                        {/*Contaminant Self Assessment Reminder*/}
                        <Row >
                            <Col sm="12">
                                <span className="smart-list" style={{ fontSize: "15px", fontWeight: "700" }}>
                                    Contaminant Self Assessment Reminder
                                </span>
                            </Col>
                        </Row>
                       
                        {/*Risk Evaluation Ratings*/}
                        <Row style={{ marginTop: "-10px" }} >
                            <Col sm="12">
                                <span className="smart-list" style={{ fontSize: "15px", fontWeight: "700" }}>
                                    Risk Evaluation Ratings
                                </span>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col >
                                <label style={{ fontSize: "14px", fontWeight: "700" }}>Note: these Ratings have been pulled from the Risk Evaluation page in Part 3 - Risk Assessment</label>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="6">
                                <div>Nitrogen</div>
                            </Col>
                            <Col sm="6">
                                <span style={{ padding: "5px", color: "#ffff", backgroundColor: nutrientManagement.nitrogenRating == 'High' ? 'rgb(224, 0, 0)' : (nutrientManagement.nitrogenRating == 'Medium' ? 'rgb(255, 134, 3)' : (nutrientManagement.nitrogenRating == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{nutrientManagement.nitrogenRating}
                                </span>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="6">
                                <div>Phosphorus</div>
                            </Col>
                            <Col sm="6">
                                <span style={{ padding: "5px", color: "#ffff", backgroundColor: nutrientManagement.phosphorusRating == 'High' ? 'rgb(224, 0, 0)' : (nutrientManagement.phosphorusRating == 'Medium' ? 'rgb(255, 134, 3)' : (nutrientManagement.phosphorusRating == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{nutrientManagement.phosphorusRating}</span>
                            </Col>
                        </Row>

                        {/*Olsen P Tests*/}
                        <Row style={{ marginTop: "20px" }}>
                            <Col sm="12">
                                <span className="smart-list" style={{ fontSize: "15px", fontWeight: "700" }}>
                                    Olsen P Tests
                                </span>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="6">
                                <Label className="text-capitalize">Latest Olsen P Test Date</Label>
                            </Col>
                            <Col sm="6">
                                <DatePicker style={{ width: `100%` }} className="form-control"
                                    selected={nutrientManagement.opttestdate} onChange={(date) => setNutrientManagement({ ...nutrientManagement, opttestdate: date, opttestdateText: getParsedDate(date) })}
                                    name="opttestdate" id="opttestdate"
                                    dateFormat="dd/MM/yyyy"
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="6">
                                <Label className="text-capitalize">Latest Olsen P</Label>
                            </Col>
                            <Col sm="6">
                                <Input type="text" name="latestOlsenP" id="latestOlsenP" value={nutrientManagement.latestOlsenP}
                                    onChange={handleInputChange} />
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="6">
                                <Label className="text-capitalize">Optimal Olsen P Range</Label>
                            </Col>
                            <Col sm="6">
                                <Input type="text" name="olsenPRange" id="olsenPRange" value={nutrientManagement.olsenPRange}
                                    onChange={handleInputChange} />
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="6">
                                <Label className="text-capitalize">If you don't use Olsen P, please explain what measurement and fertiliser is used</Label>
                            </Col>
                            <Col sm="6">
                                <Input type="textarea" name="measurementAndFertiliserUsed" id="measurementAndFertiliserUsed" value={nutrientManagement.measurementAndFertiliserUsed}
                                    onChange={handleInputChange} />
                            </Col>
                        </Row>
                        {/*Fertiliser Applications */}
                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="12">
                                <span className="smart-list" style={{ fontSize: "15px", fontWeight: "700" }}>
                                    Fertiliser Applications
                                </span>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="6">
                                <Label className="text-capitalize">Is Phosphate fertiliser applied to the vineyard?</Label>
                            </Col>
                            <Col sm="6">
                                <Input type="select" onChange={handleInputChange} name="dontApplyPhosphateFertiliser" id="dontApplyPhosphateFertiliser" value={nutrientManagement.dontApplyPhosphateFertiliser}>
                                    <option value="" >Select</option>
                                    <option key={uuid()} value="Yes">Yes</option>
                                    <option key={uuid()} value="No">No</option>
                                </Input>
                            </Col>
                        </Row>
                        {
                            nutrientManagement.dontApplyPhosphateFertiliser == 'Yes' &&
                            <>
                                <Row style={{ marginTop: "10px" }}>
                                    <Col sm="6">
                                        <Label className="text-capitalize">When was the last phosphate fertiliser applied</Label>
                                    </Col>
                                    <Col sm="6">
                                        <DatePicker style={{ width: `100%` }} className="form-control"
                                            selected={nutrientManagement.fertiliserapplieddate} onChange={(date) => setNutrientManagement({ ...nutrientManagement, fertiliserapplieddate: date, applieddateText: getParsedDate(date) })}
                                            name="fertiliserapplieddate" id="fertiliserapplieddate"
                                            showMonthYearPicker
                                            placeholderText="Select Month and Year"
                                            dateFormat="MM/yyyy"
                                        />
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Col sm="6">
                                        <Label className="text-capitalize">Type of fertiliser</Label>
                                    </Col>
                                    <Col sm="6">
                                        {nutrientManagement.fertiliserTypeList != undefined && nutrientManagement.fertiliserTypeList != null &&
                                            <Input type="select" onChange={handleInputChange} name="fertiliserType" id="fertiliserType" value={nutrientManagement.fertiliserType}>
                                                <option value={0} >Select</option>
                                                {nutrientManagement.fertiliserTypeList.map(Option =>
                                                    <option key={uuid()} value={Option.id}>{Option.value}</option>
                                                )}
                                            </Input>
                                        }

                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Col sm="6">
                                        <Label className="text-capitalize">How was it spread</Label>
                                    </Col>
                                    <Col sm="6">
                                        {nutrientManagement.spreadTypeList != undefined && nutrientManagement.spreadTypeList != null &&
                                            <Input type="select" onChange={handleInputChange} name="spreadType" id="spreadType" value={nutrientManagement.spreadType}>
                                                <option value={0} >Select</option>
                                                {nutrientManagement.spreadTypeList.map(Option =>
                                                    <option key={uuid()} value={Option.id}>{Option.value}</option>
                                                )}
                                            </Input>
                                        }
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Col sm="6">
                                        <Label className="text-capitalize">Application Rate (use Litres if Fertigation or Kg/Ha if other)</Label>
                                    </Col>
                                    <Col sm="6">
                                        <Input type="text" name="applicationRate" id="applicationRate" value={nutrientManagement.applicationRate}
                                            onChange={handleInputChange} />
                                    </Col>
                                </Row>
                            </>
                        }
                        

                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="12">
                                <span className="smart-list" style={{ fontSize: "15px", fontWeight: "700" }}>
                                    Nitrogen Fertiliser
                                </span>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col sm="6">
                                <Label className="text-capitalize">Are you planning to use Nitrogen fertiliser (excluding foliar sprays) in the next 5 years?</Label>
                            </Col>
                            <Col sm="6">
                                <Input type="select" onChange={handleInputChange} name="areYouPlanningToUseNitrogenFertiliserInFiveYears" id="areYouPlanningToUseNitrogenFertiliserInFiveYears" value={nutrientManagement.areYouPlanningToUseNitrogenFertiliserInFiveYears}>
                                    <option value="" >Select</option>
                                    <option key={uuid()} value="Yes">Yes</option>
                                    <option key={uuid()} value="No">No</option>
                                </Input>
                            </Col>
                        </Row>
                        {
                            nutrientManagement.areYouPlanningToUseNitrogenFertiliserInFiveYears == 'Yes' &&
                            <>
                                <Row style={{ marginTop: "10px" }}>
                                    <Col sm="6">
                                        <Label className="text-capitalize">What method of application will be used?  E.g. fertigation, band spreading, broadcast</Label>
                                    </Col>
                                    <Col sm="6">
                                        <Input type="text" name="methodOfApplication" id="methodOfApplication" value={nutrientManagement.methodOfApplication}
                                            onChange={handleInputChange} />
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Col sm="6">
                                        <Label className="text-capitalize">What type of nitrogen fertiliser are you planning on using?  E.g. calcium ammonium sulphate (CAN), urea </Label>
                                    </Col>
                                    <Col sm="6">
                                        <Input type="text" name="typeOfNitrogenFertiliser" id="typeOfNitrogenFertiliser" value={nutrientManagement.typeOfNitrogenFertiliser}
                                            onChange={handleInputChange} />
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Col sm="6">
                                        <Label className="text-capitalize">What rate will the nitrogen fertiliser be applied? E.g. kg/ha, g/vine, L/ha</Label>
                                    </Col>
                                    <Col sm="6">
                                        <Input type="text" name="rateOfNitrogenFertiliser" id="rateOfNitrogenFertiliser" value={nutrientManagement.rateOfNitrogenFertiliser}
                                            onChange={handleInputChange} />
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Col sm="6">
                                        <Label className="text-capitalize">When will the nitrogen fertiliser be applied? E.g. 4 weeks after budburst, December each year.</Label>
                                    </Col>
                                    <Col sm="6">
                                        <Input type="text" name="whenWillNitrogenFertiliserBeApply" id="whenWillNitrogenFertiliserBeApply" value={nutrientManagement.whenWillNitrogenFertiliserBeApply}
                                            onChange={handleInputChange} />
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Col sm="6">
                                        <Label className="text-capitalize">General notes - any other comments</Label>
                                    </Col>
                                    <Col sm="6">
                                        <Input type="text" name="nitrogenFertiliserNotes" id="nitrogenFertiliserNotes" value={nutrientManagement.nitrogenFertiliserNotes}
                                            onChange={handleInputChange} />
                                    </Col>
                                </Row>
                            </>
                        }
                        <>
                            <br />
                            <WholeFarmActionView outlineCenter={nutrients.outlineCenter} handleOpenWholeActionPopup={handleOpenWholeActionPopup} open={false} showArrow={true}></WholeFarmActionView>
                            <br />
                        </>
                        

                        
                        
                        {show_HistoricalActions &&  
                            <HistoricalActions sectionId={sectionObj.id} open={false} showArrow={true}></HistoricalActions>    
                        }
                        <Documents refid={farmId} uploadType="Nutrients" open={false} showArrow={true}></Documents>
                        {
                            sectionObj.isFarmAPTActionsReq && <ActionsToConsider sectionId={sectionObj.id} />
                        }

                       
                    </Col>

                </Row>
            }
            {/*<Modal size="lg" isOpen={nutrientPopup.showNutrientPopup} backdrop={false} className="nutrientPopup">*/}
            {/*    <Form>*/}
            {/*        <ModalHeader toggle={handleNutrientPopupClose} >Add Soil Test Trip</ModalHeader>*/}
            {/*        <ModalBody>*/}
            {/*            <Row>*/}
            {/*                <Col sm="6">*/}
            {/*                    <FormGroup>*/}
            {/*                        <Label>LU</Label>*/}
            {/*                        {largeEnterpriseDetails.LMUList != undefined && largeEnterpriseDetails.LMUList != null &&*/}
            {/*                            <Input type="select" className="float-end validate" disabled={lmustyle} onChange={handleNutrientItemsChange} name="LMUId" id="LMUId" value={nutrientPopup.LMUId}>*/}
            {/*                                <option key={uuid()} value={0} >Select LU</option>*/}
            {/*                                {LMUParentList.map(Option =>*/}
            {/*                                    <>*/}
            {/*                                        <option key={uuid()} key={Option.id} value={Option.id} className="option-parent">{Option.name}</option>*/}
            {/*                                        {*/}
            {/*                                            largeEnterpriseDetails.LMUList.filter(child => child.lmuId == Option.id).map(ChildOption =>*/}
            {/*                                                <option key={uuid()} key={ChildOption.id} value={ChildOption.id}> {"\u00a0\u00a0"} {ChildOption.name}</option>*/}
            {/*                                            )*/}
            {/*                                        }*/}
            {/*                                    </>*/}
            {/*                                )}*/}
            {/*                            </Input>*/}
            {/*                        }*/}
            {/*                    </FormGroup>*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*            <Row>*/}
            {/*                <Col sm="6">*/}
            {/*                    <FormGroup>*/}
            {/*                        <Label>Name</Label>*/}
            {/*                        <Input type="text" className="validate" name="Name" id="Name" value={nutrientPopup.Name} onChange={handleNutrientItemsChange} required />*/}
            {/*                    </FormGroup>*/}
            {/*                </Col>*/}
            {/*                <Col sm="2">*/}
            {/*                    <FormGroup>*/}
            {/*                        <Label>Colour</Label>*/}
            {/*                        <Input type="color" name="color" id="color" value={nutrientPopup.color} onChange={handleNutrientItemsChange} />*/}
            {/*                    </FormGroup>*/}
            {/*                </Col>*/}
            {/*                <MapType itemPopupMaptype={nutrientPopupMaptype}></MapType>*/}
            {/*            </Row>*/}
            {/*            <Row style={{ display: `none` }}>*/}
            {/*                <Col>*/}
            {/*                    <FormGroup>*/}
            {/*                        <Label>Description</Label>*/}
            {/*                        <Input type="textarea" name="Description" id="Description" value={nutrientPopup.Description} onChange={handleNutrientItemsChange} required />*/}
            {/*                    </FormGroup>*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*            <Row>*/}
            {/*                <Col sm="6">*/}
            {/*                    <FormGroup>*/}
            {/*                        <Label>Date</Label>*/}
            {/*                        <DatePicker style={{ width: `100%` }} className="form-control"*/}
            {/*                            selected={nutrientPopup.date} onChange={(date1) => setNutrientPopup({ ...nutrientPopup, date: date1, dateText: getParsedDate(date1) })}*/}
            {/*                            name="date" id="date"*/}
            {/*                            dateFormat="dd/MM/yyyy"*/}
            {/*                        />*/}
            {/*                    </FormGroup>*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*            <Row>*/}
            {/*                <Col sm="6">*/}
            {/*                    <FormGroup>*/}
            {/*                        <Label>Optimal Olsen P Range</Label>*/}
            {/*                        <Input type="text" name="optimalRange" id="optimalRange" value={nutrientPopup.optimalRange} onChange={handleNutrientItemsChange} required />*/}
            {/*                    </FormGroup>*/}
            {/*                </Col>*/}
            {/*                <Col sm="6">*/}
            {/*                    <FormGroup>*/}
            {/*                        <Label>Latest OLSEN P Value Range</Label>*/}
            {/*                        <Input type="text" name="olsenpValueRange" id="olsenpValueRange" value={nutrientPopup.olsenpValueRange} onChange={handleNutrientItemsChange} required />*/}
            {/*                    </FormGroup>*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*        </ModalBody>*/}
            {/*        <ModalFooter>*/}
            {/*            <div>*/}
            {/*                {nutrientPopup.id !== 0 &&*/}
            {/*                    <>*/}
            {/*                    {itemDeletesaving ?*/}
            {/*                        <>*/}
            {/*                            < Button onClick={(id) => deleteItembyId(nutrientPopup.id)} color="danger" disabled>*/}
            {/*                                <Row>*/}
            {/*                                    <Col sm="6">*/}
            {/*                                        <span>*/}
            {/*                                            {' '}Saving*/}
            {/*                                        </span>*/}
            {/*                                    </Col>*/}
            {/*                                    <Col sm="6">*/}
            {/*                                        <Spinner size="sm">*/}
            {/*                                            Saving...*/}
            {/*                                        </Spinner>*/}
            {/*                                    </Col>*/}
            {/*                                </Row></Button>{' '}*/}
            {/*                        </>*/}
            {/*                        :*/}
            {/*                        <>*/}
            {/*                            <Button onClick={(id) => deleteItembyId(nutrientPopup.id)} color="danger">*/}
            {/*                                Archive*/}
            {/*                            </Button>{' '}*/}
            {/*                        </>*/}
            {/*                    }</>}{' '}*/}
            {/*                {saving ?*/}
            {/*                    <>*/}
            {/*                        <Button onClick={handleNutrientSubmit} id="saveCropArea" color="success" disabled size="sm">*/}
            {/*                            <Row>*/}
            {/*                                <Col sm="6">*/}
            {/*                                    <span>*/}
            {/*                                        {' '}Saving*/}
            {/*                                    </span>*/}
            {/*                                </Col>*/}
            {/*                                <Col sm="6">*/}
            {/*                                    <Spinner size="sm">*/}
            {/*                                        Saving...*/}
            {/*                                    </Spinner>*/}
            {/*                                </Col>*/}
            {/*                            </Row></Button>{' '}*/}
            {/*                    </>*/}
            {/*                    :*/}
            {/*                    <>*/}
            {/*                        <Button color="success" id="saveCropArea" onClick={handleNutrientSubmit} size="sm">Save</Button>{' '}*/}
            {/*                    </>*/}
            {/*                }*/}
            {/*                <Button color="primary" onClick={handleNutrientPopupClose} size="sm">Cancel</Button>*/}
            {/*            </div>*/}
            {/*        </ModalFooter>*/}
            {/*    </Form>*/}
            {/*</Modal>*/}

            {/*<Modal isOpen={nutrientDeletePopup.showNutrientDeletePopup}>*/}
            {/*    <ModalHeader toggle={handleItemDeletePopupClose} >Delete the item</ModalHeader>*/}
            {/*    <ModalBody>*/}
            {/*        Do you want to delete the item ?*/}
            {/*    </ModalBody>*/}
            {/*    <ModalFooter>*/}
            {/*        {itemDeletesaving ?*/}
            {/*            <>*/}
            {/*                <Button onClick={deleteItem} color="primary" disabled>*/}
            {/*                    <Row>*/}
            {/*                        <Col sm="6">*/}
            {/*                            <span>*/}
            {/*                                {' '}Saving*/}
            {/*                            </span>*/}
            {/*                        </Col>*/}
            {/*                        <Col sm="6">*/}
            {/*                            <Spinner size="sm">*/}
            {/*                                Saving...*/}
            {/*                            </Spinner>*/}
            {/*                        </Col>*/}
            {/*                    </Row></Button>{' '}*/}
            {/*            </>*/}
            {/*            :*/}
            {/*            <>*/}
            {/*                <Button onClick={deleteItem} color="primary">*/}
            {/*                    Yes*/}
            {/*                </Button>{' '}*/}
            {/*            </>*/}
            {/*        }*/}
            {/*        <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>*/}
            {/*    </ModalFooter>*/}
            {/*</Modal>*/}

            {showActionPopup && <Action refreshToken={refreshToken} itemList={[]} isGHGNutrient={true} selectedLUId={0} redirectPage="/nutrients" handleActionClose={handleActionClose} itemTypeId={nutrients.itemTypes[0].id} sectionName="Nutrients" sectionId={nutrients.itemTypes[0].sectionId} itemId={nutrients.farmCenter.itemId} itemName={nutrients.farmCenter.name}
                showActionPopupModal={showActionPopup} actionId={id} itemTypeSelect={nutrients.itemTypes} itemTypeDisabled={true} refreshItemDetails={refreshItemDetails} ></Action>}

            {wholeFarmActionPopup.showActionPopup && <Action refreshToken={refreshToken} width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={nutrients.itemList} redirectPage="/nutrients" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleWholeActionClose} itemTypeId={wholeFarmActionPopup.itemTypeId} sectionName={nutrients.Section} sectionId={nutrients.itemTypes[0].sectionId} itemId={wholeFarmActionPopup.itemId} itemName={wholeFarmActionPopup.itemName}
                showActionPopupModal={wholeFarmActionPopup.showActionPopup} actionId={wholeFarmActionPopup.actionId} itemTypeSelect={nutrients.outlineItemTypes} itemTypeDisabled={true} wholeFarmAction={true}></Action>}

            {riskSummaryPopup.showriskSummary && <RiskSummary refreshToken={refreshToken} section={nutrients.SectionObj} sectionId={nutrients.itemTypes[0].sectionId} riskSummaryPopup={riskSummaryPopup} handleRiskSummaryClose={handleRiskSummaryClose}></RiskSummary>}

        </div>
    )
}

export default Nutrients;